<template>
  <v-card>
    <v-card-title>
      <v-card-actions>
        <v-btn icon outlined @click="$emit('update:selected', null)">
          <v-icon>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <v-card-title>
          {{ headline }}
        </v-card-title>
      </v-card-actions>
    </v-card-title>
    <MovieWall :records="records" v-if="loaded"/>
    <v-card-text align="center" v-else>
      <v-progress-circular color="#7400b8" indeterminate/>
    </v-card-text>
  </v-card>
</template>

<script>

import MovieWall from "@/components/MovieWall";
export default {
  name: "MovieWallCard",
  components: {MovieWall},
  props: ["records", "loaded", "headline"],
}
</script>

<style scoped>

</style>
